<script setup>
// import { ref } from 'vue'
// import { useThemeStore } from '@/stores/themeStore';
// const themeStore = useThemeStore();
// themeStore.initTheme()

const isDevelopment = window.devMode || false

// console.log(isDevelopment);

</script>

<template>

   <div class="tech_app" v-show="!!isDevelopment">
      ______________
      <p id="state_bip" style="color: #ff5500;">beforeinstallprompt X</p>
      <span style="color: #ffffff;">cookie - </span>
      <span id="state_cookie_inst_app_status" style="color: #ffffff;">0</span>
      <br>
      <span style="color: #ffffff;">installing - </span>
      <span id="is_start_app_install" style="color: #ffffff;">0</span>
      <br>
      <span style="color: #ffffff;">tryInstallCount </span>
      <span id="tryInstallCount" style="color: #ffffff;">0</span>
      <br>
      <span style="color: #ffffff;">app ttttttt - </span>
      <span id="is_start_ttttttt" style="color: #ffffff;">0</span>

   </div>

</template>

<style lang="scss" scoped>
.tech_app {
   position: fixed;
   color: rgb(255, 255, 255);
   background-color: rgb(0 0 0);
   opacity: 0.7;
   top: 0;
   right: 0;
   border-radius: 0px 0px 0px 4px;
   padding: 3px;
   font-family: monospace;
   font-weight: 900;
   font-size: 0.9rem;
   text-align: left;
   text-shadow: 1px 1px 3px #000;
   z-index: 100;
}
</style>
